import { useEffect, useState } from "react"
import { useForm } from "react-hook-form"
import { toast } from "react-toastify"
import { NewDashboardScreen } from "../../screen/NewDashboardScreen"
import { isValidURL } from "../../core/utils/validateFields"
import { useScope } from "../SelectProjectCompanyContainer"
import { sendFile } from "../../core/firebase/functions"
import { isJson } from "../../core/utils/jsonVerify"
import Send from "../../core/communication/index"

import JSON__TEMPLATE from "../../core/mocks/template/struct.json"
import { customToast } from "../../components/Toast"

export const NewDashboardContainer = ({ toggleScreen, selectedDashId }) => {
  const { scope } = useScope()
  const [errorImage, setErrorImage] = useState(false)
  const [hasJsonConfig, setHasJsonConfig] = useState(true)
  const [loading, setLoading] = useState(false)
  const [coverImage, setCoverImage] = useState(null)
  const [uploadedImage, setUploadedImage] = useState(false)
  const [values, setValues] = useState({
    description: "", // require
    config: !selectedDashId?.id && JSON__TEMPLATE,
    group: "", // require
    report: "", // require
    image: "", // require
    order: 0,
  })

  const {
    register,
    handleSubmit,
    resetField,
    watch,
    formState: { errors, isValid },
  } = useForm({ mode: "onChange" })

  useEffect(() => {
    if (selectedDashId && selectedDashId.id) {
      Send.get(`/projects/${scope?.id}/dashboard/${selectedDashId.id}`)
        .then((result) => {
          setValues({
            ...result,
            config: result?.config ? JSON.parse(result.config) : [{ key: "value" }],
          })
        })
        .catch((error) => {
          console.log(error)
        })
    }
  }, [selectedDashId])

  const imageCover = watch("linkCover")

  useEffect(() => {
    if (imageCover?.length && isValidURL(imageCover)) {
      setCoverImage("")
      setUploadedImage(false)
    }
  }, [imageCover])

  useEffect(() => {
    if (!selectedDashId) {
      setHasJsonConfig(false)
    }
  }, [selectedDashId])

  const toggleJsonConfig = () => setHasJsonConfig(!hasJsonConfig)

  const onChangeInput = (name, value) => {
    if (name === "config") {
      const isJsonValid = isJson(value)

      if (!isJsonValid) {
        customToast("O conteúdo JSON é inválido", "error")
        return
      }
      value = JSON.parse(value)
    }

    setValues({ ...values, [name]: value })
  }

  const onChangeImage = (e) => {
    const { files } = e.target

    if (files[0].type !== "image/png") {
      setErrorImage(true)
      setCoverImage("")
    } else {
      let fileReader = new FileReader()
      fileReader.readAsDataURL(files[0])

      fileReader.onload = (event) => {
        setCoverImage(event.target.result)
        setUploadedImage(true)
      }
      e.target.value = null
      setErrorImage(false)
    }
  }

  const handleRemoveDash = async () => {
    try {
      const response = await Send.delete(`/projects/dashboard/${selectedDashId?.id}`);
      customToast('Dashboard removido', 'success');
      toggleScreen();
    } catch(error) {
      console.log("Error", error);
      customToast('Erro ao remover Dashbord', 'error');
    }
  }

  const onSave = async (data) => {
    setLoading(true)
    const { linkCover } = data

    const uploadImage =
      coverImage &&
      (await sendFile(coverImage, values.description?.replaceAll(" ", "-"), "image")
        .then((response) => response)
        .catch((e) => {
          customToast("Erro ao salvar imagem", "error")
          console.log(e)
        }))

    if (coverImage && !uploadImage) return

    if (hasJsonConfig) {
      values.group = ""
      values.report = ""
      values.config = JSON.stringify(values.config)
    } else {
      values.config = null
    }

    if (selectedDashId && selectedDashId?.id) {
      await Send.put(`/projects/dashboard/${selectedDashId?.id}`, {
        ...values,
        project: scope?.id,
        image: (linkCover ? linkCover : uploadImage) || values?.image || "",
      })
        .then((result) => console.log(result))
        .catch((e) => {
          customToast("Erro ao atualizar dashboard", "error")
          console.log(e)
        })
    } else {
      await Send.post(`/projects/${scope?.id}/dashboard`, {
        ...values,
        project: scope?.id,
        image: (linkCover ? linkCover : uploadImage) || "",
      })
        .then((result) => console.log(result))
        .catch((error) => {
          customToast("Erro ao salvar novo dashboard", "error")
          console.log(e)
        })
    }

    setTimeout(() => {
      setLoading(false)
      toggleScreen()
    }, 1000)
  }

  return (
    <NewDashboardScreen
      {...{
        onChangeInput,
        values,
        toggleScreen,
        register,
        errors,
        isValid,
        handleSubmit,
        resetField,
        watch,
        onChangeImage,
        uploadedImage,
        loading,
        errorImage,
        toggleJsonConfig,
        hasJsonConfig,
        selectedDashId,
        handleRemoveDash
      }}
      handleSubmit={handleSubmit(onSave)}
    />
  )
}
